import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { Submission } from '../submission.js';
import { persistGrammarFiOutcomes } from './persist-grammar-fi-outcomes.js';

export const deleteGrammarErrorMutation = registerMutation({
  operationName: 'deleteGrammarErrorMutation',
  type: () => Boolean,
  params: [
    { name: 'submissionId', type: () => String },
    { name: 'mainTaskId', type: () => String },
    { name: 'errorId', type: () => String },
  ],
  resolve: (submissionId: string, mainTaskId: string, errorId: string) => async () => {
    try {
      const col = await getRawCollection(Submission._collectionName);
      const submission = await col.findOne({ _id: submissionId } as any);
      if (!submission) return false;

      const mainTaskIndex = (submission as any).taskSubmissions?.findIndex(
        (t: any) => String(t._id) === String(mainTaskId),
      );
      if (mainTaskIndex === undefined || mainTaskIndex === -1) return false;

      const path = `taskSubmissions.${mainTaskIndex}.grammarEvaluation`;

      await col.updateOne(
        { _id: submissionId } as any,
        { $pull: { [`${path}.errors`]: { _id: errorId } } } as any,
      );

      // Recalculate errorCount and fehlerindex after removal.
      const updated = await col.findOne({ _id: submissionId } as any);
      const evaluation = (updated as any)?.taskSubmissions?.[mainTaskIndex]?.grammarEvaluation;
      const errors: any[] = evaluation?.errors ?? [];
      const wordCount: number = evaluation?.wordCount ?? 0;
      const errorCount = errors.length;
      const fehlerindex = wordCount > 0 ? (errorCount / wordCount) * 100 : 0;

      await col.updateOne(
        { _id: submissionId } as any,
        { $set: { [`${path}.errorCount`]: errorCount, [`${path}.fehlerindex`]: fehlerindex } } as any,
      );

      // The error count feeds the per-student Fehlerindex deduction — recompute it (fire-and-forget).
      const examId = String((submission as any).examId ?? '');
      if (examId) void persistGrammarFiOutcomes(examId);

      return true;
    } catch (err) {
      logger.error(
        { err, submissionId, mainTaskId, errorId, context: 'DELETE_GRAMMAR_ERROR' },
        'Failed to delete grammar error',
      );
      return false;
    }
  },
});
